export default __webpack_public_path__ + "static/team-sviluppo-dedicato-outsourcing-astrorei-157042eb9b15d1f1d3182436c8d8314a.jpg";